import { AllSameKeyValuesEnforcer, createSameKeyValues, makeMapFromListOfObjectsAndKey } from '../helpers/helpers';
import { Ranking } from './events.data';
import { SponsorStati } from './share.data';
import { addExcludedEntityTemplateKeys, EntityBase, entityProps } from './entity.shared.data';

export const sponsorStatus: AllSameKeyValuesEnforcer<SponsorStati> = { Confirmed: 'Confirmed', Pending: 'Pending', Cancelled: 'Cancelled' }

const SponsorTabs = [ 'details', 'sessions', 'quickNotes', 'contact', 'tasks', 'assets' ]
export const sponsorTabs = createSameKeyValues(SponsorTabs)

export const makeDefaultSponsorTypes = () => [
  { name: 'Gold Sponsors', id: 'Gold', rank: 3 }, // higher ranks are better
  { name: 'Silver Sponsors', id: 'Silver', rank: 2 },
  { name: 'Bronze Sponsors', id: 'Bronze', rank: 1 },
]

export interface Sponsor extends EntityBase{
  description?: string
  callToAction?: string
  callToActionUrl?: string
  WFContact?: string // an email for a WFWorker
  contactEmail?: string
  contactNumber?: string
  sponsorTypeId?: string
  hideLabels?: boolean // hack for display options in timeline items
  hideLogo?: boolean // another hack
}

export const sponsorOnlyProps: AllSameKeyValuesEnforcer<Omit<Sponsor, keyof EntityBase>> = { 
  contactNumber: 'contactNumber', sponsorTypeId: 'sponsorTypeId', hideLogo: 'hideLogo', description: 'description', 
  callToAction: 'callToAction', callToActionUrl: 'callToActionUrl', WFContact: 'WFContact', contactEmail: 'contactEmail' 
}
export const sponsorProps: AllSameKeyValuesEnforcer<Sponsor> = { ...entityProps, ...sponsorOnlyProps }
export const excludedTemplateSponsorProps: Set<keyof Sponsor> = new Set(['hideLabels', 'hideLogo']) 
addExcludedEntityTemplateKeys(excludedTemplateSponsorProps)

export const getSponsorGroupings = ( sponsors: { [sId: string]: Sponsor }, sponsorTypes: Ranking[]): 
  { sponsorGroupings: { sponsorTypeId: string, ids: string[] }[], sponsorTypesMap: { [sId: string]: Ranking } } => {
  const sponsorGroupingsMap: { [sponsorTypeId: string]: string[] } = {}
  const emptyGrouping = { sponsorTypeId: '', ids: [] }
  const sponsorTypesMap = makeMapFromListOfObjectsAndKey(sponsorTypes, 'id')
  sponsorTypes.forEach(type => sponsorGroupingsMap[type.id] = [])
  Object.values(sponsors).forEach(({ id, sponsorTypeId }) => {
    if (!sponsorTypeId || !sponsorTypesMap[sponsorTypeId]) emptyGrouping.ids.push(id)
    else sponsorGroupingsMap[sponsorTypeId].push(id)
  })
  const sponsorGroupings = Object.entries(sponsorGroupingsMap)
    .map(([ sponsorTypeId, ids ]) => ({ sponsorTypeId, ids }))
    .filter(({ ids }) => ids.length)
    .sort((groupA, groupB) => sponsorTypesMap[groupA.sponsorTypeId].rank < sponsorTypesMap[groupB.sponsorTypeId].rank ? 1 : -1)
  if (emptyGrouping.ids.length) sponsorGroupings.push(emptyGrouping)
  sponsorGroupings.forEach(grouping => grouping.ids.sort((aId, bId) => sponsors[aId].name.toLocaleUpperCase() < sponsors[bId].name.toLocaleUpperCase() ? -1 : 1))
  // console.log({ sponsorGroupings, emptyGrouping })
  return { sponsorGroupings, sponsorTypesMap }
}